import { connect } from 'react-redux'

import Progress from '../components/progress'

function mapStateToProps(state) {
    return {
        appState: state.appState,
        account: state.account,
    }
}

function mapDispatchToProps() {
    return {}
}

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(Progress)



// WEBPACK FOOTER //
// ./app/containers/progress.js